module.exports = __webpack_public_path__ + "img/IMG_6984_L_Black_MockedUp.acf6c17f.jpg";